import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  StyledHeader,
  StyledTd,
} from '../../../Pages/Questionnaire/index.styles';
import { companiesColors } from '../../../Pages/SuperDashboard/data';
import CommentBtn from './commentBtn';
import TableButton from '../../TableButton';
import { toLocaleNumber } from '../../../../utils/helpers';

export default function AssetsPreview({
  state,
  id,
  setActive,
  setState,
  language,
}: {
  state: {
    emission_shared: number;
    emission_amount_is_known: boolean;
    name: string;
    leased_asset_data_emission_unknown: {
      type_of_fuel: string;
      unit_of_fuel: string;
      amount_of_fuel_in_period: string;
      spending_on_electricity_pln_or_kwh_in_period: string;
      unit_of_energy_usage: string;
    };
    leased_asset_data_emission_known: {
      amount_kg_eq_co2_in_period: string;
    };
  }[];
  id: number;
  setActive: Function;
  setState: Function;
  language: string;
}) {
  const { t } = useTranslation();
  const handleCopy = () => {
    const tempState = [...state];
    const item = tempState[id];

    tempState.splice(id, 0, item);
    setState(tempState);
    setActive(id);
  };
  return (
    <StyledHeader>
      <StyledTd width={22} color={companiesColors[id]}>
        <p>{state[id]?.name || ''}</p>
        <CommentBtn state={state} id={id} />
      </StyledTd>
      <StyledTd width={22} color={companiesColors[id]}>
        {t(
          !!state[id].leased_asset_data_emission_unknown?.type_of_fuel
            ? `dropdowns.${state[id].leased_asset_data_emission_unknown?.type_of_fuel}`
            : ''
        )}
      </StyledTd>
      <StyledTd width={12} color={companiesColors[id]}>
        {state[id].leased_asset_data_emission_unknown &&
        state[id].leased_asset_data_emission_unknown.amount_of_fuel_in_period
          ? toLocaleNumber(
              state[id].leased_asset_data_emission_unknown
                ?.amount_of_fuel_in_period,
              language
            )
          : ''}
      </StyledTd>
      <StyledTd width={22} color={companiesColors[id]}>
        {t(
          !!state[id].leased_asset_data_emission_unknown?.unit_of_fuel
            ? `dropdowns.${state[id].leased_asset_data_emission_unknown?.unit_of_fuel}`
            : ''
        )}
      </StyledTd>
      <StyledTd width={22} color={companiesColors[id]}>
        {state[id].emission_shared
          ? (state[id].emission_shared * 100).toFixed(2)
          : 0}
      </StyledTd>
      <StyledTd
        width={0}
        color={companiesColors[id]}
        lastCallCustom
        numberOfIcons="two"
      >
        <TableButton hoverText="copy" icon="copy" onClick={handleCopy} />
        <TableButton
          hoverText="edit"
          icon="edit"
          onClick={() => setActive(id)}
        />
      </StyledTd>
    </StyledHeader>
  );
}
